import { UnitConversion } from '../inputs/UnitConversion';

function getMinMaxValue(option, min_max, inputs, result) {
  let min_max_value;
  if (option[min_max] === undefined) {
    return null;
  } else if (typeof option[min_max] === 'string') {
    if (
      inputs[option[min_max]] !== undefined &&
      inputs[option[min_max]] !== null
    ) {
      min_max_value = inputs[option[min_max]];
    } else if (
      result[option[min_max]] !== undefined &&
      result[option[min_max]] !== null
    ) {
      min_max_value = result[option[min_max]];
    } else {
      return null;
    }
  } else if (typeof option[min_max] === 'number') {
    min_max_value = option[min_max];
  } else {
    return null;
  }
  if (typeof min_max_value === 'string') {
    if (min_max_value.includes('%')) {
      min_max_value = min_max_value.replace('%', '');
    }
    min_max_value = min_max_value?.trim()
      ? parseFloat(min_max_value.trim())
      : null;
  }
  return min_max_value;
}

function ValidateValue(option, value, inputs, result) {
  const maxValue = getMinMaxValue(option, 'max', inputs, result);
  const minValue = getMinMaxValue(option, 'min', inputs, result);
  const checkedValue =
    typeof value === 'object' && value !== null && value !== undefined
      ? Math.max(...Object.values(value))
      : value;

  let valueTotest = checkedValue;
  if (typeof valueTotest === 'string' && valueTotest.includes('%')) {
    valueTotest = parseFloat(valueTotest.replace('%', '').trim());
  }
  valueTotest = parseStringToNumber(valueTotest);

  let validateValue = true;
  let warning = '';

  if (typeof valueTotest === 'number') {
    const name = option.name.replace(/\s*\[.*?\]\s*/g, '').trim();
    const unitMatch = option.name.match(/\[(.*?)\]/);
    const unit = unitMatch ? unitMatch[1] : '';

    const formattedMax = (() => {
      if (maxValue === null) return null;

      const { displayedValue, displayedUnit } = UnitConversion(
        maxValue,
        inputs.unit_system,
        unit
      );

      return {
        value: Math.round(displayedValue * 10) / 10,
        unit: displayedUnit,
      };
    })();

    const formattedMin = (() => {
      if (minValue === null) return null;

      const { displayedValue, displayedUnit } = UnitConversion(
        minValue,
        inputs.unit_system,
        unit
      );

      return {
        value: Math.round(displayedValue * 10) / 10,
        unit: displayedUnit,
      };
    })();

    if (maxValue !== null && valueTotest > maxValue) {
      validateValue = false;
      warning += `Maximum ${name} is ${formattedMax.value} ${formattedMax.unit}. `;
    }

    if (minValue !== null && valueTotest < minValue) {
      validateValue = false;
      warning += `Minimum ${name} is ${formattedMin.value} ${formattedMin.unit}. `;
    }

    if (option.step && !Number.isInteger(Number(valueTotest))) {
      validateValue = false;
      warning += `Value must be an integer. `;
    }
  }

  return { validateValue, warning };
}

const parseStringToNumber = (value) => {
  const parsedValue = parseFloat(value);
  if (!isNaN(parsedValue) && parsedValue.toString() === value) {
    return parsedValue;
  }
  return value;
};

export default ValidateValue;
